import Axios from "axios";
import { apiUrl } from "../environment";
import store from "../components/store/Store";
import { userlogout } from "../components/slice/authService";

function authRequestInterceptor(config) {
  config.headers.Accept = "application/json";
  return config;
}

export const axiosSAML = Axios.create({
  baseURL: apiUrl,
});

axiosSAML.interceptors.request.use(authRequestInterceptor);

axiosSAML.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      store.dispatch(userlogout());
    }
    return Promise.reject(error);
  }
);
